'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

let moduleName = 'appRouter';

angular.module(moduleName, [])
    .config(['$stateProvider', '$locationProvider', '$urlRouterProvider', function ($stateProvider, $locationProvider, $urlRouterProvider) {

        $stateProvider.state('login', {
            url: '/login',
            params: { },
            controller: ['$scope', '$location', '$window', 'AuthenticationService', 'FlashService', require('./theme/login/controller')],
            template: require('./theme/login/view.html'),
            data : {
                class_name: 'login'
            }
        });

        $stateProvider.state('recovery', {
            url: '/recovery',
            params: { },
            controller: ['$scope', '$location', '$window', 'AuthenticationService', 'FlashService', 'Restangular', require('./theme/recovery/controller')],
            template: require('./theme/recovery/view.html'),
            data : {
                class_name: 'login recovery'
            }
        });

        $stateProvider.state('register', {
            url: '/register',
            params: { },
            controller: ['$scope', '$location', '$window', '$anchorScroll', 'AuthenticationService', 'FlashService', 'Restangular', 'CifService', require('./theme/register/controller')],
            template: require('./theme/register/view.html'),
            data : {
                class_name: 'register'
            }
        });

        $stateProvider.state('promo', {
            url: '/promo',
            params: { },
            controller: ['$scope', '$location', '$window', '$anchorScroll', 'AuthenticationService', 'FlashService', 'Restangular', 'CifService',  '$mdDialog', '$filter', 'promo', require('./theme/promo/controller')],
            template: require('./theme/promo/view.html'),
            data : {
                class_name: 'register promo'
            },
            resolve : {
                promo: ['Restangular', 'AuthenticationService', '$location', function (Restangular, AuthenticationService, $location) {
                    return Restangular
                        .oneUrl('promo', AuthenticationService.Api.Public+'promo/'+$location.search().token)
                        .get()
                        .then(data => {
                            if(data)
                                return data.id ? data : data.data;

                            return null;
                        });
                }],
            }
        });

        $stateProvider.state('request-promo', {
            url: '/request-promo',
            params: { },
            controller: ['$scope', '$location', '$window', '$anchorScroll', 'AuthenticationService', 'FlashService', 'Restangular', require('./theme/request-promo/controller')],
            template: require('./theme/request-promo/view.html'),
            data : {
                class_name: 'register promo'
            }
        });

        $stateProvider.state('gameTest', {
            url: '/game/test/:id',
            params: { },
            parent: 'ng-admin',
            controller: ['$scope', 'Restangular', '$stateParams', 'NgAdminConfiguration', require('./theme/game/test/controller')],
            template: require('./theme/game/test/view.html'),
            data : {
                class_name: 'test'
            }
        });

        $stateProvider.state('downloads', {
            url: '/downloads',
            params: {},
            parent: 'ng-admin',
            controller: ['$scope', '$location', require('./theme/download/controller')],
            template: require('./theme/download/view.html'),
            data: {
                class_name: 'download'
            },
            resolve: {}
        });

        $stateProvider.state('options', {
            url: '/options',
            params: {},
            parent: 'ng-admin',
            controller: ['$scope', '$location', 'products', 'settings', '$anchorScroll', 'FlashService', 'Restangular', require('./theme/options/controller')],
            template: require('./theme/options/view.html'),
            data: {
                class_name: 'options'
            },
            resolve: {
                products : ['Restangular', function(Restangular){
                    return Restangular
                        .all('products')
                        .getList({_filters: '{"type":"licence"}', _sortDir: "ASC", _sortField: "name"})
                        .then(data => {
                            return data.data ? data.data : data;
                        });
                }],
                settings : ['Restangular', function(Restangular){
                    return Restangular
                        .all('settings')
                        .getList()
                        .then(data => {
                            return data.data ? data.data : data;
                        });
                }],
            }
        });

        $stateProvider.state('account', {
            url: '/account',
            params: { },
            parent: 'ng-admin',
            controller: ['$scope', 'Restangular', 'current', 'licences', 'active', 'unused', require('./theme/account/controller')],
            template: require('./theme/account/view.html'),
            data : {
                class_name: 'account'
            },
            resolve : {
                licences : ['Restangular', function(Restangular){
                    if(!HasRole(['superadmin', 'company', 'prenscriptor'])) return false;

                    return Restangular
                        .all('licences')
                        .getList({_sortDir: "DESC", _sortField: "updated"})
                        .then(data => {
                            return data.data ? data.data : data;
                        });
                }],
                current: ['Restangular', function(Restangular){
                    return Restangular
                        .one('user')
                        .get()
                        .then(data => {
                            return data.data ? data.data : data;
                        });
                }],
                active: ['Restangular', function(Restangular){
                    if(!HasRole(['superadmin', 'company', 'prenscriptor'])) return false;

                    return Restangular
                        .all('subscriptions/active')
                        .getList()
                        .then(data => {
                            return data.data ? data.data : data;
                        });
                }],
                unused: ['Restangular', function(Restangular){
                    if(!HasRole(['superadmin', 'company', 'prenscriptor'])) return false;

                    return Restangular
                        .all('subscriptions/unused')
                        .getList()
                        .then(data => {
                            return data.data ? data.data : data;
                        });
                }]
            }
        });

        $stateProvider.state('profile', {
            url: '/profile',
            params: { },
            parent: 'ng-admin',
            controller: ['$scope', '$anchorScroll', 'AuthenticationService', 'FlashService', 'Restangular', 'states', 'prescriberTypes', 'user', 'progression', '$location',
                require('./theme/profile/controller')],
            template: require('./theme/profile/view.html'),
            data : {
                class_name: 'profile',
            },
            resolve : {
                states : ['Restangular', function(Restangular){
                    return Restangular
                        .all('states')
                        .getList({_filters: '{"country":"' + 1 + '"}', _sortDir: "ASC", _sortField: "name"})
                        .then(data => {
                            return data.data ? data.data : data;
                        });
                }],
                prescriberTypes : ['Restangular', function(Restangular){
                    return Restangular
                        .all('prescriberTypes')
                        .getList({_sortDir: "ASC", _sortField: "description"})
                        .then(data => {
                            return data.data ? data.data : data;
                        });
                }],
                user: ['Restangular', function(Restangular){
                    return Restangular
                        .one('user')
                        .get()
                        .then(data => {
                            return data.data ? data.data : data;
                        });
                }]
            }
        });

        $stateProvider.state('change-password', {
            url: '/change-password',
            params: { },
            parent: 'ng-admin',
            controller: ['$scope', '$anchorScroll', 'AuthenticationService', 'FlashService', 'Restangular', 'progression', '$location',
                require('./theme/change-password/controller')],
            template: require('./theme/change-password/view.html'),
            data : {
                class_name: 'profile',
            },
            resolve : {

            }
        });

        $stateProvider.state('purchasesthank', {
            url: '/purchase/thank',
            params: {},
            parent: 'ng-admin',
            controller: ['$scope',
                require('./theme/purchases/thanks/controller')],
            template: require('./theme/purchases/thanks/view.html'),
            data: {
                class_name: 'purchases',
            }
        });

        $stateProvider.state('purchaseserror', {
            url: '/purchase/error',
            params: {},
            parent: 'ng-admin',
            controller: ['$scope',
                require('./theme/purchases/error/controller')],
            template: require('./theme/purchases/error/view.html'),
            data: {
                class_name: 'purchases',
            }
        });

        $stateProvider.state('paypalsuccess', {
            url: '/paypal/success',
            params: {},
            parent: 'ng-admin',
            controller: ['$scope',
                require('./theme/paypal/success/controller')],
            template: require('./theme/paypal/success/view.html'),
            data: {
                class_name: 'purchases paypal success',
            },
            resolve: {
                success: ['Restangular', 'AuthenticationService', '$location', function (Restangular, AuthenticationService, $location) {
                    return Restangular
                        .one('purchase', $location.search().purchase)
                        .one('paypal', $location.search().token)
                        .post()
                        .then(function (data) {
                                if (data)
                                    return data.id ? data : data.data;

                                return null;
                            }
                        );
                }]
            }
        });


        $stateProvider.state('paypalcancel', {
            url: '/paypal/cancel',
            params: {},
            parent: 'ng-admin',
            controller: ['$scope',
                require('./theme/paypal/cancel/controller')],
            template: require('./theme/paypal/cancel/view.html'),
            data: {
                class_name: 'purchases paypal cancel',
            }
        });

        $stateProvider.state('paypalerror', {
            url: '/paypal/error',
            params: {},
            parent: 'ng-admin',
            controller: ['$scope',
                require('./theme/paypal/error/controller')],
            template: require('./theme/paypal/error/view.html'),
            data: {
                class_name: 'purchases paypal error',
            }
        });


        $stateProvider.state('purchases', {
            url: '/purchases/{id}',
            params: { },
            parent: 'ng-admin',
            controller: ['$scope', '$sce', '$timeout', '$anchorScroll', '$filter', 'Api', 'Restangular', 'FlashService', 'user', 'states', 'subscriptions', 'games', 'purchase', 'active_licences',
                require('./theme/purchases/controller')],
            template: require('./theme/purchases/view.html'),
            data : {
                class_name: 'purchases',
            },
            resolve : {
                user: ['Restangular', function(Restangular){
                    return Restangular
                        .one('user')
                        .get()
                        .then(data => {
                            return data.data ? data.data : data;
                        });
                }],
                states : ['Restangular', function(Restangular){
                    return Restangular
                        .all('states')
                        .getList({_filters: '{"country":"' + 1 + '"}', _sortDir: "ASC", _sortField: "name"})
                        .then(data => {
                            return data.data ? data.data : data;
                        });
                }],
                games : ['Restangular', function(Restangular){
                    return Restangular
                        .all('products')
                        .getList({_filters: '{"type":"game"}', _sortDir: "ASC", _sortField: "name"})
                        .then(data => {
                            return data.data ? data.data : data;
                        });
                }],
                active_licences : ['Restangular', function(Restangular){
                    return Restangular
                        .all('licences')
                        .getList()
                        .then(data => {
                            return data.data ? data.data : data;
                        });
                }],
                subscriptions : ['Restangular', function(Restangular){
                    return Restangular
                        .all('products')
                        .getList({_filters: '{"type":"subscription"}', _sortDir: "ASC", _sortField: "name"})
                        .then(data => {
                            return data.data ? data.data : data;
                        });
                }],
                purchase: ['Restangular', '$stateParams', function(Restangular, $stateParams){

                    if(!$stateParams.id || !$stateParams.id.match(/\d+/g)) return $stateParams.id;

                    return Restangular
                        .one("purchase", $stateParams.id)
                        .get()
                        .then(data => {
                            return data.data ? data.data : data;
                        });
                }]

            }
        });

        $stateProvider.state('purchase_licence', {
            url: '/purchase_licence/{id}',
            params: { },
            parent: 'ng-admin',
            controller: ['$scope', '$sce', '$timeout', '$anchorScroll', '$filter', 'Api', 'Restangular', 'FlashService', 'user', 'states', 'licences', 'purchase', 'active_licences',
                require('./theme/purchase_licence/controller')],
            template: require('./theme/purchase_licence/view.html'),
            data : {
                class_name: 'purchase_licence'
            },
            resolve : {
                user: ['Restangular', function (Restangular) {
                    return Restangular
                            .one('user')
                            .get()
                            .then(data => {
                            return data.data ? data.data : data;
                });
                }],
                states: ['Restangular', function (Restangular) {
                    return Restangular
                            .all('states')
                            .getList({_filters: '{"country":"' + 1 + '"}', _sortDir: "ASC", _sortField: "name"})
                            .then(data => {
                            return data.data ? data.data : data;
                });
                }],
                licences: ['Restangular', function (Restangular) {
                    return Restangular
                            .all('products')
                            .getList({_filters: '{"type":"licence"}', _sortDir: "ASC", _sortField: "name"})
                            .then(data => {
                            return data.data ? data.data : data;
                });
                }],
                active_licences: ['Restangular', function (Restangular) {
                    return Restangular
                            .all('licences')
                            .getList()
                            .then(data => {
                            return data.data ? data.data : data;
                });
                }],
                purchase: ['Restangular', '$stateParams', function(Restangular, $stateParams){

                    if(!$stateParams.id || !$stateParams.id.match(/\d+/g)) return $stateParams.id;

                    return Restangular
                            .one("purchase", $stateParams.id)
                            .get()
                            .then(data => {
                            return data.data ? data.data : data;
                });
                }]
            }
        });

        $stateProvider.state('licences', {
            url: '/licences',
            params: { },
            parent: 'ng-admin',
            controller: ['$scope', '$timeout', '$mdDialog', '$filter', 'Restangular', 'FlashService', 'progression', 'licences', 'users', 'invoices',
                require('./theme/licences/controller')],
            template: require('./theme/licences/view.html'),
            data : {
                class_name: 'purchases',
            },
            resolve : {
                licences : ['Restangular', function(Restangular){

                    return Restangular
                        .all('licences')
                        .getList({_sortDir: "DESC", _sortField: "updated"})
                        .then(data => {
                            return data.data ? data.data : data;
                        });
                }],
                users: ['Restangular', function(Restangular){
                    let filters = {_sortDir: "ASC", _sortField: "name"};
                    let workers = GetData().currentUser.workers;

                    if(HasRole('company')){
                        if(!workers.length)
                            return [];
                        else
                            filters._filters = '{"id":['+workers.join(',')+']}';
                    }

                    return  Restangular
                        .all('users')
                        .getList(filters)
                        .then(data => {
                            return data.data ? data.data : data;
                    });
                }],
                invoices : ['Restangular', function(Restangular){
                    return Restangular
                        .all('invoices')
                        .getList({_sortDir: "DESC", _sortField: "updated"})
                        .then(data => {
                            return data.data ? data.data : data;
                        });
                }]

            }
        });

        $stateProvider.state('invoices', {
            url: '/invoices',
            params: { },
            parent: 'ng-admin',
            controller: ['$scope', '$timeout', '$mdDialog', '$filter','Restangular', 'FlashService', 'purchases', 'invoices',
                require('./theme/invoices/controller')],
            template: require('./theme/invoices/view.html'),
            data : {
                class_name: 'purchases invoices',
            },
            resolve : {
                purchases : ['Restangular', function(Restangular){
                    return Restangular
                        .all('purchases')
                        .getList({_sortDir: "DESC", _sortField: "updated"})
                        .then(data => {
                            return data.data ? data.data : data;
                        });
                }],
                invoices : ['Restangular', function(Restangular){
                    return Restangular
                        .all('invoices')
                        .getList({_sortDir: "DESC", _sortField: "updated"})
                        .then(data => {
                            return data.data ? data.data : data;
                        });
                }]

            }
        });

        $stateProvider.state('subscriptions', {
            url: '/subscriptions',
            params: { },
            parent: 'ng-admin',
            controller: ['$scope', '$timeout', '$mdDialog', 'Restangular', 'FlashService', 'progression', 'subscriptions', 'users', '$filter',
                require('./theme/subscriptions/controller')],
            template: require('./theme/subscriptions/view.html'),
            data : {
                class_name: 'purchases subscriptions',
            },
            resolve : {
                subscriptions : ['Restangular', function(Restangular){
                    return Restangular
                        .all('subscriptions/active')
                        .getList({_sortDir: "ASC", _sortField: "finalize"})
                        .then(data => {
                            return data.data ? data.data : data;
                        });
                }],
                users: ['Restangular', function(Restangular){
                    let filters = {_sortDir: "ASC", _sortField: "name"};
                    let workers = GetData().currentUser.workers

                    if(HasRole('company')){
                        if(!workers.length)
                            return [];
                        else
                            filters._filters = '{"prescriber":['+workers.join(',')+']}';
                    }

                    return  Restangular
                        .all('users')
                        .getList(filters)
                        .then(data => {
                            return data.data ? data.data : data;
                        });
                }]
            }
        });

        $stateProvider.state('loading', {
            url: '/loading',
            params: { },
            parent: '',
            controller: ['$scope', '$location', '$window',
                require('./theme/loading/controller')],
            template: require('./theme/loading/view.html'),
            data : {
                class_name: 'page-loading',
            },
        });

        $locationProvider.hashPrefix('');
        $urlRouterProvider.otherwise('account');
        $urlRouterProvider.when('dashboard', 'account');
    }]);

exports.default = moduleName;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./js/router.js
 **/